module.exports = __webpack_public_path__ + "static/img/FASHION_JEWEL.91ae4b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FASHION_JEWEL.jpg
// module id = 43/z
// module chunks = 1